// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"private-market-notice_clearfix_3hcW4","marketNotice":"private-market-notice_marketNotice_2cJ2I"};